import { useCallback, useEffect } from 'react';
import http from 'hub-http/clients/apiClient';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H1 } from 'foundations-components/transitional/components/H1';
import { H5 } from 'foundations-components/transitional/components/H5';
import { H7 } from 'foundations-components/transitional/components/H7';
import { HR } from 'foundations-components/transitional/components/HR';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { View } from 'foundations-components/components/View';
import BrowserUrlDisplay from '../browserUrlDisplay/BrowserUrlDisplay';
import Routes from 'ContentUtils/Routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const updateCustomDomainSetupNextReminderDate = customDomainSetupNextReminderDate => {
  return http.patch('cms-user-settings', {
    data: {
      customDomainSetupNextReminderDate
    }
  });
};
const BasePostPublishDomainSetupModal = ({
  closeModal,
  publishedContentUrl,
  usageTracker,
  isStaging = false
}) => {
  useEffect(() => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'view',
      screen: 'detail'
    });
  }, [usageTracker]);
  const handleStartCustomDomainSetup = useCallback(() => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'clicked-add-custom-domain-button',
      screen: 'detail'
    });
    window.open(Routes.settings('domains'));
  }, [usageTracker]);
  const handleSnoozeModal = () => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'clicked-remind-me-tomorrow-button',
      screen: 'detail'
    });
    const nextReminderDate = I18n.moment().add(1, 'days').valueOf();
    updateCustomDomainSetupNextReminderDate(nextReminderDate).then(() => closeModal()).catch(() => {});
  };
  const handleDismissModal = () => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'clicked-do-not-show-me-again-button',
      screen: 'detail'
    });
    updateCustomDomainSetupNextReminderDate(-1).then(() => closeModal()).catch(() => {});
  };
  const handleCloseModal = () => {
    usageTracker.track('setupCustomDomainModalInteraction', {
      action: 'clicked-close-modal',
      screen: 'detail'
    });
    // Close the modal, but don't snooze or dismiss via cms-user-settings
    closeModal();
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 600,
    children: [/*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: handleCloseModal
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: "success"
      }), /*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ContentComponents.postPublishDomainSetupModal.mainHeader"
        })
      }), /*#__PURE__*/_jsx("p", {
        children: isStaging ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ContentComponents.postPublishDomainSetupModal.stagingSubheader"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ContentComponents.postPublishDomainSetupModal.mainSubheader"
        })
      }), /*#__PURE__*/_jsx(BrowserUrlDisplay, {
        url: publishedContentUrl
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Flex, {
        paddingInline: "1000",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(HR, {}), /*#__PURE__*/_jsx(Box, {
          shrink: 0,
          paddingInline: "400",
          children: /*#__PURE__*/_jsx(H7, {
            marginBlock: "0",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ContentComponents.postPublishDomainSetupModal.ctaHeader"
            })
          })
        }), /*#__PURE__*/_jsx(HR, {})]
      }), /*#__PURE__*/_jsxs(View, {
        paddingInline: "1000",
        marginBlockStart: "600",
        children: [/*#__PURE__*/_jsx(H5, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.ctaSubheader"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.ctaBody"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleStartCustomDomainSetup,
          use: "primary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.addDomainButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleSnoozeModal,
          use: "secondary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.remindMeTomorrowButton"
          })
        }), /*#__PURE__*/_jsx(Button, {
          onClick: handleDismissModal,
          use: "secondary",
          size: "sm",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ContentComponents.postPublishDomainSetupModal.doNotShowAgainButton"
          })
        })]
      })]
    })]
  });
};
export default BasePostPublishDomainSetupModal;